// extracted by mini-css-extract-plugin
export default {"notFoundPage":"ui_notFoundPage__dKCKw","subTitle":"ui_subTitle__vTY54"};